import { ReactNode } from 'react';

import { Typography } from '@mui/material';

export const Group = ({
	label,
	children,
}: {
	label?: string;
	children: ReactNode;
}): ReactNode => {
	return !label ? children : (
			<li>
				<Typography
					variant="caption"
					sx={{
						display: 'block',
						position: 'sticky',
						top: '0',
						padding: '4px 10px',
						width: '100%',
						backgroundColor: 'accent.light',
						zIndex: 100,
						'& + ul': { padding: 0 },
					}}
				>
					{label}
				</Typography>
				<ul>{children}</ul>
			</li>
		);
};
